import {
  PlateEditor,
  unwrapNodes,
  Value,
  withoutNormalizing,
} from '@udecode/plate';
import { Path } from 'slate';

export const removeEmojiSearchNode = <V extends Value>(
  editor: PlateEditor<V>,
  path: Path
) =>
  withoutNormalizing(editor, () => {
    unwrapNodes(editor, {
      at: path,
    });
  });
